if($('.type-detail').length){
    $('.p-detail-info').append($('.p-code').clone())
    if($('#productsAlternative').length){
        $('.p-info-wrapper').append($('#productsAlternative'));
    }
    if($('.extended-description').length){
        $('.extended-description .detail-parameters tr th:contains("Kategorie")').closest('tr').hide()
        $('.p-info-wrapper').append($('.extended-description'))
        
    }
    $('.p-image-wrapper').append($('.product-top>div:not(".col-lg-6") .flags'))
    $('.p-info-wrapper').append($('.p-detail-inner-header').clone())
    $('.p-info-wrapper').append($('.p-detail-info').clone())
    $('.p-info-wrapper').append('<div class="customCart"></div>')
   
    $('.customCart').append($('.p-final-price-wrapper'))
    $('.customCart').append($('.add-to-cart'))
    if($('.variant-list').length>0){
        $('.variant-list select').each(function(){
            var optionLength = $(this).find('option').length
            var data_parameter_id = $(this).data('parameter-id')
            var html_var = '<div class="custom-variant"><div class="h3">'+$(this).attr('data-parameter-name')+'</div>'
            html_var += '<div class="custom-variant-wrap" data-param-id="'+data_parameter_id+'">'
            $(this).find('option').each(function(){
                var data_value = $(this).attr('value')
                if ($.isNumeric($(this).val())) {
                    html_var += '<div class="variant" data-value="'+data_value+'" data-parameter-id="'+data_parameter_id+'" data-param-val="'+data_parameter_id+'-'+data_value+'">'
                    html_var += '<div class="text">'+$(this).text()+'</div>'
                    html_var += '</div>'
                }
            })
            html_var += '</div></div>'
            $(this).after(html_var)
            $(this).closest('.variant-list select').hide()
           $(this).closest('.variant-list span').hide()
          
        })

        var necessaryVariantData = shoptet.variantsSplit.necessaryVariantData;
        for (var parentKey in necessaryVariantData) {
            if (necessaryVariantData.hasOwnProperty(parentKey)) {
                var variant = necessaryVariantData[parentKey];
                $('.custom-variant-wrap .variant[data-param-val="'+parentKey+'"]').attr('data-price-id', variant.id).attr('data-avail', variant.availabilityName.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/ /g, '-')).attr('data-notSouldOut', variant.isNotSoldOut)
            }
        }
        
    }
    $(document).on('click', '.custom-variant-wrap .variant', function(){
        const variantData = $(this).data('value')
        const variantParameterId = $(this).data('parameter-id')
        $("select[data-parameter-id='"+variantParameterId+"'] option").filter(function (){return $(this).attr('value') == variantData }).change().prop("selected", true)
        var selector = '.variant-list .hidden-split-parameter, .variant-list .split-parameter';
        var $splitParameters = $(selector);
        $splitParameters.trigger('change');
        $(this).closest('.custom-variant-wrap[data-param-id="'+variantParameterId+'"]').find(".variant:not([data-value='"+variantData+"'])").removeClass("active");
        $(this).addClass("active");    
        $("select[data-parameter-id='"+variantParameterId+"']")[0].dispatchEvent(new Event('change'));
        $('.custom-variant-wrap .variant').each(function(){
            const variantData = $(this).data('value')
            const variantParameterId = $(this).data('parameter-id')
            const unavailable = $("select[data-parameter-id='"+variantParameterId+"']  option[value='" + variantData + "']").hasClass("unavailable-option")    
            if (unavailable === true) {
                $(this).addClass("unavailable").removeClass("active")
            }
            else{
                $(this).removeClass("unavailable")
            } 
        })
        $('.p-info-wrapper .availabityData .availRow').addClass('no-display')
        if($('.variant-list select option').length>1){
            
            $('.p-info-wrapper .availabityData .availRow[data-code="'+$('.p-info-wrapper .p-detail-inner-header .p-code span').not('.p-code-label').not('.no-display').not('.noDisplay').text().trim()+'"]').removeClass('no-display')        
        }
        else{
            $('.p-info-wrapper .availabityData .availRow[data-code="'+$('.p-info-wrapper .p-detail-inner-header .p-code span').not('.p-code-label').text().trim()+'"]').removeClass('no-display')        

        }
    })
    


    $(document).on('click', '#jsUnavailableCombinationMessage a', function(){
        $('.custom-variant-wrap .variant').removeClass('unavailable')
    })
    $(document).ready(function(){
        $(".custom-variant-wrap").each(function() {
            var $variants = $(this).find("div.variant");
            if ($variants.length === 1) {
                $variants.addClass("active");
            }
          });
        var urlParams = new URLSearchParams(window.location.search);
        var parameterValueId = urlParams.get("parameterValueId");
        var $divToHighlight = $("div.variant[data-value='" + parameterValueId + "']");
        if ($divToHighlight.length > 0) {
            $divToHighlight.addClass("active");
        }
    })

    $(document).ready(function(){
        if($('.variant-list').length){
            $('.availability-value').hide()
                $('.p-info-wrapper').append('<div class="availabityData"><h3>Dostupnost:</h3><div class="left"><div class="availRow"><span class="title">Nejdříve si zvolte variantu</span></div></div><div class="right text-center"><a href="/prodejny/" class="stockButton"><img src="https://cdn.myshoptet.com/usr/626727.myshoptet.com/user/documents/upload/sablona-nemazat/usp/prodejny.svg" alt="x-army usp">2 prodejny v Praze</a></div></div>')
                var stockInfo = dataLayer[0].shoptet.stocks;
                var stockMap = {};
                $.each(stockInfo, function(index, stock) {
                    stockMap[stock.id] = stock.title;
                });
                var productCodes = dataLayer[0].shoptet.product.codes;
                $.each(productCodes, function(index, codeInfo) {
                    if (typeof codeInfo.stocks !== "undefined") {
                        $.each(codeInfo.stocks, function(index, stock) {
                            var stockTitle = stockMap[stock.id];
                            $('.availabityData .left').append('<div class="availRow no-display" data-code="'+codeInfo.code+'"><span class="title">'+stockTitle+'</span><span class="count">'+stock.quantity+' ks</span></div>')
                        });
                    }
                    else{
                        if($('.availRow').length){
                            $('.availabityData .left .availRow').addClass('showIt').html($('.availability-value').closest('div').html())
                        }
                        
                    }
                   
                }); 

            if($('.variant-list select option').length < 2){
                $('.availRow').addClass('no-display')
                $('.p-info-wrapper .availabityData .availRow[data-code="'+$('.p-info-wrapper .p-detail-inner-header .p-code span').not('.p-code-label').text().trim()+'"]').removeClass('no-display')        
            }
            else{   
            }
        }
        else{
            $('.availability-value').hide()
            $('.p-info-wrapper').append('<div class="availabityData"><h3>Dostupnost:</h3><div class="left"></div><div class="right text-center"><a href="/prodejny/" class="stockButton"><img src="https://cdn.myshoptet.com/usr/626727.myshoptet.com/user/documents/upload/sablona-nemazat/usp/prodejny.svg" alt="x-army usp">2 prodejny v Praze</a></div></div>')
            var stockInfo = dataLayer[0].shoptet.stocks;
            var stockMap = {};
            $.each(stockInfo, function(index, stock) {
                stockMap[stock.id] = stock.title;
            });
            var productCodes = dataLayer[0].shoptet.product.codes;
            $.each(productCodes, function(index, codeInfo) {
                if (typeof codeInfo.stocks !== "undefined") {
                    $.each(codeInfo.stocks, function(index, stock) {
                        var stockTitle = stockMap[stock.id];
                        $('.availabityData .left').append('<div class="availRow"><span class="title">'+stockTitle+'</span><span class="count">'+stock.quantity+' ks</span></div>')
                    });
                }
                else{
                    if(!$('.availRow').length){
                        $('.availabityData .left').addClass('showIt').html($('.availability-value').html())
                    }
                    
                }
            });                    
        }
    })
}